import { FocusStyleManager } from '@blueprintjs/core'
import React from 'react'
import { Provider } from 'react-redux'
import AppError from './components/AppError'
import Router from './router'
import store from './store'
import './style.scss'

FocusStyleManager.onlyShowFocusOnTabs()

export default () => (
  <AppError>
    <Provider store={store}>
      <Router />
    </Provider>
  </AppError>
)
